import { useMemo } from 'react'
import { msg, t, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Link } from 'react-router-dom'
import { CellContext, createColumnHelper } from '@tanstack/react-table'
import { Button, Stack } from '@mui/material'

import Table from '@/components/ui/tables/Table'
import { useSnackbar } from 'notistack'

type ExpertiseMeetingData = {
  id: string
  name: string
  patient: string
  startDate: string
}

const columnHelper = createColumnHelper<ExpertiseMeetingData>()

export function ExpertiseMeetingsTable({ data }: { data: ExpertiseMeetingData[] }) {
  const lingui = useLingui()

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: lingui._(t`Name`),
      }),
      columnHelper.accessor('patient', {
        header: lingui._(t`Patient`),
      }),
      columnHelper.accessor('startDate', {
        header: lingui._(t`Start date`),
      }),
      columnHelper.display({
        id: 'actions',
        header: lingui._(t`Actions`),
        cell: ActionsCell,
        meta: {
          sx: { width: '1%', whiteSpace: 'nowrap' },
        },
      }),
    ],
    [lingui]
  )

  return <Table container="div" columns={columns} data={data} disableGlobalSearch disableGutters infiniteScroll />
}

function ActionsCell(props: CellContext<ExpertiseMeetingData, unknown>) {
  const { row } = props
  const { enqueueSnackbar } = useSnackbar()
  return (
    <Stack direction="row" spacing={1}>
      <Button component={Link} to={`/expertise-meetings/${row.original.id}`} variant="contained">
        <Trans>Join</Trans>
      </Button>
      <Button
        onClick={() => {
          navigator.clipboard.writeText(`${window.location.origin}/expertise-meetings/${row.original.id}`)
          enqueueSnackbar(t`Expertise meeting link copied`, { variant: 'success' })
        }}
        variant="outlined"
      >
        <Trans>Copy link</Trans>
      </Button>
    </Stack>
  )
}
